import React, { Component } from 'react'
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl'

import { callApi, API_ROOT, getAuthHeaders } from '../services/fetchService'

import FaIcon from '../components/FaIcon'

import { Row, Col, Card, Alert, Button, Upload, message } from 'antd'



class _Backup extends Component {

    static propTypes = {
        intl: intlShape.isRequired
    }

    download = () => {
        const { intl } = this.props
        callApi({
            endpoint: 'backup',
            method: 'GET'
        }).then((data) => {
            window.open(data.url)
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
    }

    handleChange = (info) => {
        const { intl } = this.props
        if (info.file.status === 'done') {
            message.success(intl.formatMessage({id: 'backup.restore.uploadSuccess'}))
        } else if (info.file.status === 'error') {
            if (info.file.response.code === 13) {
                message.warn(intl.formatMessage({id: 'backup.restore.wrongFileType'}))
            } else if (info.file.response.code === 14) {
                message.warn(intl.formatMessage({id: 'backup.restore.wrongBackupFile'}))
            } else {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
            }
        }
    }

    /**
     * Render view
     */
    render() {
        const uploadProps = {
            name: 'file',
            action: API_ROOT + 'backup',
            headers: getAuthHeaders(),
            onChange: this.handleChange,
            showUploadList: false
        }

        return (
            <div>
                <h1><FaIcon icon="download" fixedWidth /> <FormattedHTMLMessage id="backup.title" /></h1>
                <Row gutter={24}>
                    <Col lg={12}>
                        <Card title={<span><FaIcon icon="download" /><FormattedMessage id="backup.backup" /></span>}>
                            <p><FormattedMessage id="backup.backup.message" /></p>
                            <Alert message={<FormattedMessage id="backup.backup.info" />} type="info" showIcon />
                            <br />
                            <Button onClick={this.download}><FaIcon icon="download" /> <FormattedMessage id="backup.backup.download" /></Button>
                        </Card>
                    </Col>
                    <Col lg={12}>
                        <Card title={<span><FaIcon icon="upload" /><FormattedMessage id="backup.restore" /></span>}>
                            <p><FormattedMessage id="backup.restore.message" /></p>
                            <Alert message={<FormattedHTMLMessage id="backup.restore.info" />} type="warning" showIcon />
                            <br />
                            <Upload { ...uploadProps }>
                                <Button type="danger"><FaIcon icon="upload" /> <FormattedMessage id="backup.restore.upload" /></Button>
                            </Upload>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }

}

export default injectIntl(_Backup)


// WEBPACK FOOTER //
// ./src/views/Backup.js